<div class="header-bar">
  <h1>
    Emergency Contact
    <span *ngIf="userData"
      >for {{ userData.firstName + ' ' + userData.lastName + ' (' + userData.email + ')' }}</span
    >
  </h1>
</div>
<div class="grid" style="margin: 12px">
  <div class="col-12">
    <div class="card">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="field grid">
          <label for="fullName" class="col-3">Full Name*</label>
          <div class="col-9">
            <input
              id="fullName"
              type="text"
              pInputText
              formControlName="fullName"
              class="form-component"
              style="width: 100% !important"
            />
            <div class="text-danger">
              <small *ngIf="f.fullName.invalid && f.fullName.touched" class="p-error">
                Full Name is required
              </small>
            </div>
          </div>
        </div>

        <div class="field grid">
          <label for="relationshipId" class="col-3">Relationship*</label>
          <div class="col-9">
            <p-dropdown
              id="relationshipId"
              [options]="relationshipOptions"
              formControlName="relationshipTypeId"
              placeholder="Select Relationship"
              [style]="{ width: '100%' }"
            ></p-dropdown>
            <div class="text-danger">
              <small
                *ngIf="f.relationshipTypeId.invalid && f.relationshipTypeId.touched"
                class="p-error"
              >
                Relationship is required
              </small>
            </div>
          </div>
        </div>

        <div class="field grid">
          <label for="phoneNumber" class="col-3">Phone Number*</label>
          <div class="col-9">
            <input
              id="phoneNumber"
              type="tel"
              pInputText
              formControlName="phoneNumber"
              class="form-component"
              style="width: 100% !important"
            />
            <div class="text-danger">
              <small
                *ngIf="f.phoneNumber.errors?.required && f.phoneNumber.touched"
                class="p-error"
              >
                Phone Number is required
              </small>

              <small *ngIf="f.phoneNumber.errors?.pattern && f.phoneNumber.touched" class="p-error">
                Invalid phone number format
              </small>
            </div>
          </div>
        </div>

        <div class="field grid">
          <label for="emailAddress" class="col-3">Email Address</label>
          <div class="col-9">
            <input
              id="emailAddress"
              type="email"
              pInputText
              formControlName="emailAddress"
              class="form-component"
              style="width: 100% !important"
            />
          </div>
        </div>

        <div class="field grid">
          <label for="addressLine1" class="col-3">Address Line 1</label>
          <div class="col-9">
            <input
              id="addressLine1"
              type="text"
              pInputText
              formControlName="addressLine1"
              class="form-component"
              style="width: 100% !important"
            />
          </div>
        </div>

        <div class="field grid">
          <label for="city" class="col-3">City</label>
          <div class="col-9">
            <input
              id="city"
              type="text"
              pInputText
              formControlName="city"
              class="form-component"
              style="width: 100% !important"
            />
          </div>
        </div>

        <div class="field grid">
          <label for="postcode" class="col-3">Postcode</label>
          <div class="col-9">
            <input
              id="postcode"
              type="text"
              pInputText
              formControlName="postcode"
              class="form-component"
              style="width: 100% !important"
            />
          </div>
        </div>

        <div class="text-right">
          <div>
            <button (click)="onClose()" pButton label="Back" class="ui-button"></button>
            <button
              type="submit"
              pButton
              label="Save"
              [disabled]="form.invalid || saving"
              class="ui-button"
            ></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
